/* global $ */
import Headroom from 'headroom.js'

import './jquery.slicknav.js'

import './slicknav.css'

const setSlickNav = async () => {
  $('#menu').slicknav({
    appendTo: '#slicknav-menu-container',
    closedSymbol: '+',
    openedSymbol: '<span class="opened">-</span>',
    closeOnClick: true
  })

  let slickNavElem = document.querySelector('.slicknav_menu')

  var contact = $('.contact-info-links')
  if(contact) {
    $('.slicknav_nav').append(contact.clone())
  }

  var social_media = $('.social_media')
  if(social_media) {
    $('.slicknav_nav').append(social_media.clone())
  }
  $(window).on('click', function(e) {
    if ($('.slicknav_btn').hasClass('slicknav_open')) {
      // Check if the click was outside of .slicknav_nav
      if ($(e.target).closest('.site-content').length > 0) {
        $('.slicknav_btn').trigger('click')
      }
    }
  });
  

  return slickNavElem
}

const setHeadroom = (slickNavElem) => {
  if (slickNavElem) {
    const headroom = new Headroom(slickNavElem, {
      offset: 200,
      tolerance: 5,
      classes: {
        // When element is initialised
        initial: 'headroom--mobile',
        // When scrolling up
        pinned: 'headroom--pinned--mobile',
        // When scrolling down
        unpinned: 'headroom--unpinned--mobile'
      },
      // Cancel unpin when Slick nav is open
      onUnpin: function () {
        if ($('.slicknav_open')[0]) this.pin()
      }
    })
    headroom.init()
  }
}

const init = async () => {
  await setSlickNav() // Initialize SlickNav, then set headroom
}

export default {
  init
}
